import { Avatar } from "@mui/material";

/** Shared cricket platform config for Xtract Sport Events & Tournaments views. */
export const CRICKET_XTRACT_PLATFORM_ICONS: Record<string, React.ReactNode> = {
  d11: <Avatar sx={{ width: 24, height: 24, bgcolor: "#e53935", fontSize: 14 }}>D11</Avatar>,
  c11: <Avatar sx={{ width: 24, height: 24, bgcolor: "#1976d2", fontSize: 14 }}>C11</Avatar>,
  mt11: <Avatar sx={{ width: 24, height: 24, bgcolor: "#43a047", fontSize: 14 }}>MT</Avatar>,
  cb11: <Avatar sx={{ width: 24, height: 24, bgcolor: "#ffb300", fontSize: 14 }}>CB</Avatar>,
  cricbuzz: <Avatar sx={{ width: 24, height: 24, bgcolor: "#2e7d32", fontSize: 11 }}>CBZ</Avatar>,
  crex: <Avatar sx={{ width: 24, height: 24, bgcolor: "#6a1b9a", fontSize: 12 }}>CRX</Avatar>,
  espn: <Avatar sx={{ width: 24, height: 24, bgcolor: "#212121", fontSize: 14 }}>E</Avatar>,
  f11: <Avatar sx={{ width: 24, height: 24, bgcolor: "#8e24aa", fontSize: 14 }}>F11</Avatar>,
  v11: <Avatar sx={{ width: 24, height: 24, bgcolor: "#795548", fontSize: 14 }}>V11</Avatar>,
  ai11: <Avatar sx={{ width: 24, height: 24, bgcolor: "#000000", fontSize: 14 }}>AI</Avatar>,
};

export const CRICKET_XTRACT_PLATFORMS = [
  { id: "espn", name: "ESPN", visible: true },
  { id: "d11", name: "Dream11", visible: true },
  { id: "c11", name: "My11Circle", visible: true },
  { id: "v11", name: "Vision11", visible: true },
  { id: "cricbuzz", name: "Cricbuzz", visible: true },
  { id: "crex", name: "CREX", visible: true },
  { id: "mt11", name: "MyTeam11", visible: false },
  { id: "cb11", name: "Cricbuzz11", visible: false },
  { id: "f11", name: "MyFab11", visible: false },
] as const;

export const CRICKET_XTRACT_PLATFORM_NAMES: Record<string, string> = {
  d11: "Dream11",
  c11: "My11Circle",
  mt11: "MyTeam11",
  cb11: "Cricbuzz11",
  cricbuzz: "Cricbuzz",
  crex: "CREX",
  espn: "ESPN",
  f11: "MyFab11",
  v11: "Vision11",
  ai11: "AI11",
};

/** Fantasy/content platforms fetched for cricket sport events (excludes espn & ai11). */
export const CRICKET_SPORT_EVENT_FETCH_PLATFORMS = [
  "d11",
  "c11",
  "mt11",
  "f11",
  "v11",
  "cb11",
  "cricbuzz",
  "crex",
] as const;
